import { createRoot } from "react-dom/client";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import * as Sentry from "@sentry/react";
import { UserTracking, BugTracking } from "@bfc-software/app-toolbox";
import { LocalStorage } from "@bfc-software/app-toolbox";

import { mswActive } from "@bfc-software/bfc-web-ui/lib/msw";

import { routeTree } from "./routeTree.gen.ts";

const router = createRouter({ routeTree, notFoundMode: "root" });

// Register the router instance for type safety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

const currentAppVersion = import.meta.env.VITE_GIT_SHA;
const lastAppVersion = LocalStorage.getStorageItem("applicationVersion");
if (currentAppVersion !== lastAppVersion) {
  LocalStorage.clearLocalStorage();
}

LocalStorage.storeApplicationVersion(currentAppVersion);

if (mswActive()) {
  const { worker } = await import("@bfc-software/bfc-web-ui/mocks/browser");
  await worker.start();
}

BugTracking.init(router);
UserTracking.init();

createRoot(document.getElementById("root")!, {
  onUncaughtError: Sentry.reactErrorHandler(),
  onCaughtError: Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler(),
}).render(<RouterProvider router={router} />);
